import EmberRouter from '@ember/routing/router';

import ENV from 'rise-ui/config/environment.js';

export default class Router extends EmberRouter {
  location = ENV.locationType;
  rootURL = ENV.rootURL;
}

Router.map(function() {
  // Note: debug-menu components are associated to routes in
  // `rise-ui/app/instance-initializers/debug/debug-menu.js`.

  this.route('catalog', function() {
    this.route('record', { path: ':catalog_record_id' }, function() {
      this.route('item', { path: 'item/:item_id' });
    });
  });
  this.route('location-detail', { path: 'location/:location_id' });
  this.route('time-series', function() {
    this.route('search');
    this.route('selection');
    this.route('output');
  });
  this.route('rise-api');
  this.route('visualizations');
  this.route('contact');
  this.route('help', function() {
    this.route('page', { path: ':help_page_id' });
    this.route('search', function() {
      this.route('topic', { path: ':help_topic_id' });
    });
  });
  this.route('about');

  this.route('announcements');
  this.route('announcement', { path: 'announcement/:announcement_id' });
  this.route('file-gallery', { path: 'file-gallery/:file_gallery_id' });
  this.route('page', { path: 'page/:page_id' });

  this.route('login');
  this.route('logout');
  this.route('account');

  this.route('page-not-found', { path: '*:' });
});
